import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    NO_CHANGE,
} from 'one-state-subject/src/types';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {
    setVisitTypesAction
} from '../../../../../../_local/one-state-visittypes-athena/src/actions';
import { format } from 'one-util-date';

export const enum Types {
    GETALLVISITTYPES_FETCH = "get-all-visittypes-fetch/athena",
}

/**
 * This function will fetch all visit types
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchGetAllVisitTypesAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, settings: {
            athenaendpoints: {
                getvisittypes
            },
            compatible: { consolidated_api_invocation, contact_center_type },
        } } = context;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(Types.GETALLVISITTYPES_FETCH),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                const callGetAllVisitTypesAPI = () => {
                    const { providerID, departmentID } = action.payload || {};
                    let headers = new Headers();
                    const responsefromAPI = server.get({
                        headers: headers,
                        path: getvisittypes + `?ProviderID=${providerID}&DepartmentID=${departmentID}`
                    })
                        .then((responsegetallvisittypes: any) => responsegetallvisittypes)
                        .catch((getallvisittypesres: any) => {
                            log.error(
                                "ccw-gadget,getallvisittypes-athena",
                                "getallvisittypes-athena", {
                                    getallvisittypesres
                                }
                            );
                            let errorbuild: ErrorObject = {
                                source: "GetAllVisitTypes",
                                type: "error",
                                status: getallvisittypesres?.status,
                                erroritems: getallvisittypesres?.errors,
                                error_date: errorDate,
                                error_time: errorTime
                            };
                            return errorbuild;
                        })
                    log.debug(
                        "ccw-gadget,getallvisittypes-athena",
                        "getallvisittypes-athena response", {
                            responsefromAPI
                        });
                    return from(responsefromAPI)
                }
                //Calling callGetAllVisitTypesAPI function here
                //the reason is we need to use pipe function.
                return callGetAllVisitTypesAPI().
                    pipe(
                        map((responsereceived: any) => TransformResponse(responsereceived, context))).
                    pipe(
                        flatMap(responseAfterTransform => {
                            const actions: any = [];
                            if (responseAfterTransform.error) {
                                actions.push(addAction(responseAfterTransform.error));
                            } else {
                                log.debug(
                                    "ccw-gadget,getallvisittypes-athena",
                                    "Dispatching visit types to store", {
                                        visittypes: responseAfterTransform.visittypes,
                                        count: responseAfterTransform.visittypes?.length
                                    });
                                actions.push(setVisitTypesAction(responseAfterTransform.visittypes));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

